import {
  Route,
  Navigate,
  Outlet,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  ScrollRestoration,
} from 'react-router-dom';
import Allocations from './pages/allocations';
import NotFound from './pages/notfound';
import ContractList from './pages/contracts/ContractList';
import Calendar from './pages/calendar';
import Companies from './pages/companies';
import Cars from './pages/cars';
import Drivers from './pages/drivers';
import Login from './pages/login';
import PasswordReset from './pages/login/PasswordReset';
import PasswordResetMail from './pages/login/PasswordResetMail';
import PrivacyPolicy from './pages/other/PrivacyPolicy';
import TermsOfService from './pages/other/TermsOfService';
import SentMail from './pages/login/SentMail';
import Mypage from './pages/mypage';
import OperatingRoute from './pages/operatingRoute';
import Contracts from './pages/contracts';
import NewContract from './pages/contracts/NewContract';
import EditContract from './pages/contracts/EditContract';
import AuthenticatedOnly from './components/common/AuthenticatedOnly';
import ErrorBoundary from './components/common/ErrorBoundary';
import ChangeUsername from './pages/mypage/changeUsername';
import ChangeEmail from './pages/mypage/changeEmail';
import ChangePassword from './pages/mypage/changePassword';
import SentChangeEmailMail from './pages/mypage/changeEmail/sentMail';
import ApproveToken from './pages/mypage/changeEmail/approveToken';
import SidebarLayout from './components/SidebarLayout';
import MaintenanceGate from './components/common/MaintenanceGate';
import CopyContract from './pages/contracts/CopyContract';
import ErrorModal from './components/common/ErrorModal';
import Loading from './components/common/Loading';
import { useSelector } from 'react-redux';
import { AppState } from './redux/store';

function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route
        element={
          <>
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
            <ErrorModal />
            <Loading />
            <ScrollRestoration />
          </>
        }
      >
        <Route
          element={
            <MaintenanceGate>
              <Outlet />
            </MaintenanceGate>
          }
        >
          <Route path="login">
            <Route index element={<AuthenticatedUser />} />
            <Route path="password-reset-mail" element={<PasswordResetMail />} />
            <Route
              path="password-reset-mail/sent-mail"
              element={<SentMail />}
            />
            <Route path="password-reset" element={<PasswordReset />} />
          </Route>
          <Route
            path="/"
            element={
              <AuthenticatedOnly>
                <SidebarLayout>
                  <ErrorBoundary>
                    <Outlet />
                  </ErrorBoundary>
                </SidebarLayout>
              </AuthenticatedOnly>
            }
          >
            <Route index element={<InitialPageForAuthenticatedUser />} />
            <Route path="mypage">
              <Route path="" element={<Mypage />} />
              <Route path="change-username" element={<ChangeUsername />} />
              <Route path="change-email">
                <Route path="" element={<ChangeEmail />} />
                <Route path="sent-mail" element={<SentChangeEmailMail />} />
                <Route path="approve-token" element={<ApproveToken />} />
              </Route>
              <Route path="change-password" element={<ChangePassword />} />
            </Route>
            <Route path="allocations" element={<Allocations />} />
            <Route path="contracts" element={<Contracts />}>
              <Route path="" element={<ContractList />} />
              <Route path="new" element={<NewContract />} />
              <Route path="edit/:id" element={<EditContract />} />
              <Route path="copy/:id" element={<CopyContract />} />
            </Route>
            <Route path="calendar" element={<Calendar />} />
            <Route path="companies" element={<Companies />} />
            <Route path="cars" element={<Cars />} />
            <Route path="drivers" element={<Drivers />} />
            <Route path="operating-route" element={<OperatingRoute />} />
          </Route>
        </Route>
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="terms-of-service" element={<TermsOfService />} />
        <Route path=".well-known">
          <Route
            path="change-password"
            element={<Navigate to="/mypage/change-password" replace />}
          />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Route>
    )
  );

  return <RouterProvider router={router}></RouterProvider>;
}
export default App;

/**
 * ログイン後、もしくは URL でルートページにアクセスしたときのリダイレクト先を定義する
 */
function InitialPageForAuthenticatedUser() {
  const isPC = window.matchMedia(
    'screen and (min-width: 768px) and (min-height: 432px)'
  ).matches;
  const to = isPC ? '/allocations' : '/operating-route';
  return <Navigate replace to={to} />;
}

/**
 * ログイン画面遷移後、アクセストークンがある場合はログイン後の初期画面にリダイレクトする
 */
function AuthenticatedUser() {
  const accessToken = useSelector(
    (state: AppState) => state.tokens.accessToken
  );
  return accessToken ? <Navigate replace to={'/'} /> : <Login />;
}
